import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react"; // 👈 import icons

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css"; // reuse same CSS

const Reset = () => {
  const navigate = useNavigate();
  const urlmain = process.env.REACT_APP_API_BASE_URL;

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false); // 👈 added

  const [loading, setLoading] = useState(false);

    const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  // 🔹 Step 1: Send OTP
  const handleSendOtp = async () => {
    if (!email) {
      toast.error("Enter your email");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${urlmain}/reset/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const res = await response.json();

      if (response.ok) {
        toast.success(res.message || "OTP sent to email");
        setStep(2);
      } else {
        toast.error(res.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 2: Verify OTP
  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Enter OTP");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${urlmain}/reset/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
      const res = await response.json();

      if (response.ok) {
        toast.success(res.message || "OTP verified");
        setStep(3);
      } else {
        toast.error(res.message || "Invalid OTP");
      }
    } catch (err) {
      toast.error("Error verifying OTP");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 3: Reset Password
  const handleResetPassword = async () => {
    if (!newPassword) {
      toast.error("Enter new password");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${urlmain}/reset/password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword }),
      });
      const res = await response.json();

      if (response.ok) {
        toast.success(res.message || "Password reset successful!");
        navigate("/login");
      } else {
        toast.error(res.message || "Failed to reset password");
      }
    } catch (err) {
      toast.error("Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="login-box">
        <h2>Reset Password</h2>

        {step === 1 && (
          <>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleSendOtp} disabled={loading}>
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button onClick={handleVerifyOtp} disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </>
        )}

       {step === 3 && (
  <>
    <div className="password-wrapper">
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Enter new password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <span className="toggle-icon" onClick={togglePassword}>
        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </span>
    </div>

    <button onClick={handleResetPassword} disabled={loading}>
      {loading ? "Resetting..." : "Reset Password"}
    </button>
  </>
)}

        <button
          className="setting-payment-cancel"
          style={{ marginTop: "10px" }}
          onClick={() => navigate("/login")}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default Reset;
